import { createApi } from '@reduxjs/toolkit/dist/query/react';

import serverRoutes from '@app/utils/server-routes';

import { baseQuery } from '@app/store/baseQuery';
import {
  SingleScaleTemplateObjectAndCreateType,
  TemplateListObjectType,
} from '@app/interfaces/qm-module/qm-score-templates/qm-score-templates.type';

export const qmScoreTemplatesApi = createApi({
  reducerPath: 'qmScoreTemplatesApi',
  tagTypes: ['qmScoreTemplatesList', 'qmScoreSingleTemplate'],
  baseQuery: baseQuery,
  endpoints: (build) => ({
    getScoreTemplatesList: build.query<TemplateListObjectType[], void>({
      query: () => ({
        url: serverRoutes.qm_scale_template_bulk,
        method: 'POST',
      }),
      providesTags: ['qmScoreTemplatesList'],
    }),
    getSingleScoreTemplate: build.query<
      SingleScaleTemplateObjectAndCreateType & { rs_template_id: string },
      { rs_template_id: string }
    >({
      query: (params) => ({
        url: serverRoutes.qm_scale_template,
        params,
      }),
      providesTags: ['qmScoreSingleTemplate'],
    }),
    createScoreTemplate: build.mutation<
      SingleScaleTemplateObjectAndCreateType,
      SingleScaleTemplateObjectAndCreateType
    >({
      query: (body) => ({
        url: serverRoutes.qm_scale_template,
        body,
        method: 'POST',
      }),
      invalidatesTags: ['qmScoreTemplatesList'],
    }),
    editScoreTemplate: build.mutation<
      SingleScaleTemplateObjectAndCreateType,
      { body: SingleScaleTemplateObjectAndCreateType; params: { rs_template_id: string } }
    >({
      query: ({ body, params }) => ({
        url: serverRoutes.qm_scale_template,
        body,
        params,
        method: 'PUT',
      }),
      invalidatesTags: ['qmScoreSingleTemplate', 'qmScoreTemplatesList'],
    }),
    deleteScoreTemplate: build.mutation<
      SingleScaleTemplateObjectAndCreateType,
      { rs_template_id: string }
    >({
      query: (params) => ({
        url: serverRoutes.qm_scale_template,
        params,
        method: 'DELETE',
      }),
      invalidatesTags: ['qmScoreTemplatesList'],
    }),
  }),
});

export const {
  useGetScoreTemplatesListQuery,
  useCreateScoreTemplateMutation,
  useDeleteScoreTemplateMutation,
  useEditScoreTemplateMutation,
  useLazyGetSingleScoreTemplateQuery,
} = qmScoreTemplatesApi;
